import { ServiceLocator } from '../../app/ServiceLocator';
import { ConnectedMetricCard } from '../components/ConnectedMetricCard';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../ts/helpers/ServerFilterClauses';
import { Metrics } from '../resources/Metrics';
import { MetricContentType } from './MetricContentType';
import { MixedContentItemDefinition, SpaceDefinition, ContentTypeFilterClause } from '../../ts/models/ContentDefinitions';
import { getGenericDefaultFilters } from '../../ts/models/getGenericDefaultFilters';

export const MetricDefinition: MixedContentItemDefinition & SpaceDefinition<'metric'> = {
  itemType: 'metric',
  contentType: 'metric',
  pluralName: () => Messages.metrics(),
  singularName: () => Messages.metric(),
  emptyStateMessage: Messages.metricsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Metrics,
  contentFilterKeys: MetricContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: ConnectedMetricCard,
  listViewIconUrl: imgPath('metrics_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['metric']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.metricUrl(contentId),
  getBasicQuery: () => {
    return Metrics.all().withExtraParams(MetricContentType.extraQueryParams);
  },
  fieldValueResourceType: 'metric',
  getContentInfo: () => { },
  headerIconPath: undefined,
  supportedDisplayModes: ['list', 'thumbnail'],
};
